/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseLangEditorViewModel } from "../types/CourseLangEditorViewModel.ts";

export const courseLangEditorViewModelSchema = z.object({
  cultureInfo: z
    .string()
    .describe(
      "Cultura do registro. Obrigatória, máximo de 10 caracteres, precisa ser uma cultura válida e não pode repetir no mesmo curso. Na atualização precisa ser igual à cultura já gravada.",
    )
    .nullish(),
  nameOfficial: z
    .string()
    .describe(
      "Nome oficial do curso neste idioma. Obrigatório, máximo de 250 caracteres.",
    )
    .nullish(),
  nameCommercial: z
    .string()
    .describe(
      "Nome comercial do curso neste idioma. Obrigatório, máximo de 250 caracteres.",
    )
    .nullish(),
  description: z
    .string()
    .describe(
      "Descrição do curso neste idioma. Máximo de 4000 caracteres. Opcional.",
    )
    .nullish(),
  contentHtml: z
    .string()
    .describe("Regimento do curso em HTML. Opcional.")
    .nullish(),
  contentInstruction: z
    .string()
    .describe(
      "Instruções exibidas ao aluno na matrícula. Máximo de 4000 caracteres. Opcional.",
    )
    .nullish(),
  contractBody: z
    .string()
    .describe(
      "Corpo do contrato de matrícula, com os marcadores de substituição do legado no padrão {Entidade.Propriedade}. Opcional.",
    )
    .nullish(),
  syllabus: z.string().describe("Ementa do curso em HTML. Opcional.").nullish(),
  detailUrl: z
    .string()
    .describe(
      "URL de detalhe do curso usada no catálogo. Máximo de 200 caracteres. Opcional.",
    )
    .nullish(),
  internationalPlanDescription: z
    .string()
    .describe(
      "Descrição do plano internacional. Máximo de 2000 caracteres. Obrigatória quando o curso é internacional. A marcação HTML enviada é removida e o valor é gravado como texto puro, preservando o comportamento do legado.",
    )
    .nullish(),
  senderApprovalRejectionDocEmail: z
    .string()
    .describe(
      "E-mail do remetente dos avisos de documentos. Máximo de 200 caracteres, precisa ser um e-mail válido e passa a ser obrigatório quando o corpo do e-mail de aprovação é informado. Opcional nos demais casos.",
    )
    .nullish(),
  senderApprovalRejectionDocName: z
    .string()
    .describe(
      "Nome de exibição do remetente dos avisos de documentos. Máximo de 200 caracteres. Opcional.",
    )
    .nullish(),
  approvalDocMailBody: z
    .string()
    .describe(
      "Corpo do e-mail de aprovação e rejeição de documentos pessoais neste idioma. Quando informado, exige o e-mail do remetente. Opcional.",
    )
    .nullish(),
  apoloActivationMailBody: z
    .string()
    .describe(
      "Corpo do e-mail de ativação Apolo. Campo sem consumidor identificado, mantido por decisão do time. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<CourseLangEditorViewModel>;
